import t from "@babel/runtime/helpers/esm/classCallCheck";
import e from "@babel/runtime/helpers/esm/createClass";
import n from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import r from "@babel/runtime/helpers/esm/getPrototypeOf";
import i from "@babel/runtime/helpers/esm/inherits";
import o, { Component as a } from "react";
import { findDOMNode as s } from "react-dom";
import { TransitionGroup as l, CSSTransition as u } from "react-transition-group";
import { withRouter as m, Switch as c } from "react-router";
var p = {
  key: "",
  isPush: true
};
var f = "REACT_HISTORIES_KEY";
var d = (sessionStorage.getItem(f) || "").split(",").filter(Boolean);

var h = function t(e, n) {
  var r = e.key || e.pathname + e.search;

  if (n && r !== p.key) {
    var i = d.lastIndexOf(r);

    if (i > -1) {
      d.splice(i + 1);
    } else {
      d.push(r);
    }

    sessionStorage.setItem(f, d.join(","));
    p = {
      isPush: i < 0,
      key: r
    };
  }

  return p.isPush;
};

var v = function (a) {
  i(m, a);

  function m() {
    var e;
    var i;
    t(this, m);

    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++) {
      a[s] = arguments[s];
    }

    i = n(this, (e = r(m)).call.apply(e, [this].concat(a)));
    i.inTransition = false;
    i.rootNode = void 0;
    i.lastTransitionNode = void 0;

    i.onEnter = function (t) {
      i.inTransition || i.setInTransition(i.inTransition = true);
      i.lastTransitionNode = t;
    };

    i.onEntering = function (t) {
      var e = i.props.timeout;

      if (t && typeof e === "number") {
        t.style.transitionDuration = t.style.WebkitTransitionDuration = t.style.MozTransitionDuration = e + "ms";
      }
    };

    i.onEntered = function (t) {
      if (i.lastTransitionNode === t) {
        i.inTransition && i.setInTransition(i.inTransition = false);
      }

      if (t) {
        var e = i.props.timeout;
        t.className = t.className.split(/\s+/).filter(function (t) {
          return !/-(?:forward|backward)-(?:enter|exit)(?:-active)?$/.test(t);
        }).join(" ");

        if (typeof e === "number") {
          t.style.transitionDuration = t.style.WebkitTransitionDuration = t.style.MozTransitionDuration = "";
        }
      }
    };

    return i;
  }

  e(m, [{
    key: "setInTransition",
    value: function t(e) {
      if (this.rootNode) {
        var n = this.props.prefix + "-in-transition";
        this.rootNode.className = this.rootNode.className.split(/\s+/).filter(function (t) {
          return t !== n;
        }).concat(e ? n : []).join(" ");
      }
    }
  }, {
    key: "componentDidMount",
    value: function t() {
      this.rootNode = s(this);
    }
  }, {
    key: "render",
    value: function t() {
      var e = this.props,
          n = e.className,
          r = e.location,
          i = e.children,
          a = e.timeout,
          s = e.prefix,
          m = e.appear,
          p = e.enter,
          f = e.exit,
          d = e.component;
      var v = {
        appear: m,
        enter: p,
        exit: f,
        component: d
      };
      var E = {
        onExit: this.onEnter,
        onExiting: this.onEntering,
        onExited: this.onEntered,
        onEnter: this.onEnter,
        onEntering: this.onEntering,
        onEntered: this.onEntered
      };
      var y = [s + "-container", "react-animated-router", n];
      return o.createElement(l, Object.assign({
        className: y.filter(Boolean).join(" "),
        childFactory: function t(e) {
          var n = s + "-" + (h(r, e.props.in) ? "forward" : "backward");
          return o.cloneElement(e, {
            classNames: n
          });
        }
      }, v), o.createElement(u, Object.assign({
        key: this.props.transitionKey || r.pathname,
        addEndListener: function t(e, n) {
          e.addEventListener("transitionend", function (t) {
            if (t.target === e) {
              n();
            }
          }, false);
        },
        unmountOnExit: true,
        timeout: a
      }, E), o.createElement(c, {
        location: r
      }, i)));
    }
  }]);
  return m;
}(a);

v.defaultProps = {
  prefix: "animated-router"
};
var E = m(v);
export default E;